import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AuthService} from '../services/auth.service';
import {CommunicationService} from '../services/communication.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

    // private secureRoutes = [`${environment.schema}://${environment.apiUrl}`];
    private secureRoutes = [`${environment.api_url}`];
    private static ERROR_401_MESSAGE = 'Неверный логин или пароль';

    constructor(private authService: AuthService, private communicator: CommunicationService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.secureRoutes.find((x) => request.url.startsWith(x))) {
            return next.handle(request);
        }

        request = request.clone({
            withCredentials: true,
            setHeaders: {Authorization: `Bearer ${this.authService.token || ''}`}
        });

        return next.handle(request).pipe(
            catchError((error) => {

                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return this.handle401Error(request, next);
                }

                throw error;
            })
        );
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // this.communicator.publish(BasicAuthInterceptor.ERROR_401_MESSAGE);
        return next.handle(request);
    }
}

